module.exports = __webpack_public_path__ + "img/image8.f41f825e.jpeg";